// src/features/orders/returnToShipperSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ✅ Define the returnToShipper item type
interface ReturnToShipper {
  id: string;
  returnId: string;
  status: string;
  assignedCompanyName?: string;
  staffName?: string;
  [key: string]: any; // allow extra fields
}

// ✅ Define the state type
interface ReturnToShipperState {
  list: any[];
  loading: boolean;
  error: string | null;
}

// ✅ Define update payload type
interface ReturnToShipperStatusUpdatePayload {
  returnId: string;
  status: string;
  assignedCompanyName?: string;
  staffName?: string;
}

// ✅ Initial state
const initialState: ReturnToShipperState = {
  list: [],
  loading: false,
  error: null,
};

// ✅ Slice
const returnToShipperSlice = createSlice({
  name: 'returnToShipper',
  initialState,
  reducers: {
    setReturnToShipperList(state, action: PayloadAction<any[]>) {
      state.list = action.payload;
      state.loading = false;
    },

    addReturnToShipper(state: any, action: PayloadAction<ReturnToShipper>) {

      const newReturnToShipper = action.payload.newRequest
        ? action.payload.newRequest
        : action.payload;

      if (Array.isArray(state.list)) {
        state.list.unshift(newReturnToShipper);
        if (state.list.length > 10) {
          state.list.pop();
        }
      } else if (state.list && Array.isArray(state.list.requests)) {
        state?.list?.requests?.unshift(newReturnToShipper);
        if (state?.list?.requests?.length > 10) {
          state?.list?.requests?.pop();
        }
      } else {
        state.list = [newReturnToShipper];
      }
    },

    returnToShipperStatusUpdate(state: any, action: PayloadAction<ReturnToShipperStatusUpdatePayload>) {
      const { returnId, status, assignedCompanyName, staffName } = action.payload;

      if (!returnId) return;

      else if (state.list && Array.isArray(state.list.requests)) {
        const returnToShipper = state.list.requests.find((p: any) => p.returnId === returnId);
        if (returnToShipper) {
          returnToShipper.status = status;
          if (assignedCompanyName) returnToShipper.assignedCompanyName = assignedCompanyName;
          if (staffName) returnToShipper.staffName = staffName;
        }
      }
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setReturnToShipperList,
  returnToShipperStatusUpdate,
  setLoading,
  setError,
  addReturnToShipper,
} = returnToShipperSlice.actions;

export default returnToShipperSlice.reducer;
